var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerpoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.902 1.74023V3.88748C16.452 3.90173 19.4198 3.86123 21.9675 3.89948C22.449 3.89948 22.47 4.32548 22.476 4.69748C22.5165 9.15398 22.4662 13.7387 22.5 18.1975C22.491 18.373 22.4955 19.0225 22.4902 19.207C22.4737 19.8242 22.1647 19.8512 21.5475 19.87C21.4485 19.87 21.1575 19.8745 21.0615 19.879C18.6758 19.867 16.29 19.8722 13.902 19.8722V22.2587L1.5 20.35V3.65423L13.902 1.74023Z",
    fill: "#D33922"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9007 4.60352H21.7757V19.1535H13.9007V17.25H19.6262V16.2938H13.9007V15.1013H19.6262V14.1473H13.9029C13.9029 13.6793 13.9029 13.212 13.8984 12.7448C14.3669 12.9138 14.8671 12.9762 15.3627 12.9276C15.8583 12.8789 16.3368 12.7204 16.7634 12.4635C17.1983 12.1778 17.5585 11.7922 17.8141 11.339C18.0697 10.8857 18.2132 10.378 18.2327 9.85802C17.1827 9.85052 16.1379 9.85352 15.0932 9.85352C15.0932 8.81552 15.1052 7.77827 15.0714 6.74252C14.6799 6.81752 14.2892 6.90002 13.8999 6.98327V4.60427",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5726 6.24316C16.3861 6.29414 17.1533 6.63937 17.731 7.21444C18.3087 7.78951 18.6574 8.55512 18.7121 9.36841C17.6621 9.38041 16.6173 9.37591 15.5703 9.37591V6.24316",
    fill: "#D33922"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32529 8.04474C6.62054 8.10699 8.19029 7.53174 9.26429 8.50299C10.2925 9.75099 10.0203 12.046 8.49629 12.7922C7.94216 13.0117 7.34144 13.087 6.75029 13.0112C6.75029 13.9442 6.74579 14.8772 6.75029 15.8095C6.27779 15.769 5.80304 15.7285 5.33054 15.6902C5.30879 13.1402 5.30429 10.5902 5.33054 8.04024",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74644 9.33463C7.21669 9.31288 7.79644 9.22738 8.11594 9.66838C8.24368 9.90851 8.31304 10.1754 8.31838 10.4473C8.32372 10.7193 8.2649 10.9887 8.14669 11.2336C7.87444 11.7249 7.25944 11.6776 6.78469 11.7346C6.73444 10.9351 6.73969 10.1364 6.74644 9.33463Z",
    fill: "#D33922"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerpoint);
export default __webpack_public_path__ + "static/media/powerpoint.74c528f0922231b5a89b9968d22a1795.svg";
export { ForwardRef as ReactComponent };